export const WithdrawalFundsEnum = {
  edit: 'edit',
  view: 'view'
}
